import React from "react";
import { Badge } from "../../../components/badge";
import CommonPagination from "../../../components/common/CommonPagination";
import {
  getNotificationIcon,
  formatRelativeTime,
} from "../../../components/home/notifications-utils";
import type { RecentActivityItem } from "../types/recentActivity.types";

interface RecentActivityListViewProps {
  activities: RecentActivityItem[];
  loading: boolean;
  error: string | null;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  labels: {
    all: string;
    loading: string;
    empty: string;
  };
}

export const RecentActivityListView: React.FC<RecentActivityListViewProps> = ({
  activities,
  loading,
  error,
  page,
  totalPages,
  onPageChange,
  labels,
}) => (
  <>
    <div className="mb-5">
      <Badge className="bg-white dark:bg-gray-800 text-[#384151] dark:text-gray-200 border border-[#00C49A] rounded-[22px] px-[15px] py-1 text-[13px] font-medium hover:bg-white hover:text-[#384151]">
        {labels.all}
      </Badge>
    </div>

    {loading ? (
      <div className="flex flex-1 items-center justify-center">
        <p className="py-8 text-muted-foreground">{labels.loading}</p>
      </div>
    ) : null}

    {!loading && error ? (
      <div className="mb-4 rounded-md border border-red-200 bg-red-50 p-3 text-red-800 dark:border-red-800 dark:bg-red-900/20 dark:text-red-200">
        {error}
      </div>
    ) : null}

    {!loading && !error && activities.length === 0 ? (
      <div className="flex flex-1 items-center justify-center">
        <p className="py-8 text-muted-foreground dark:text-gray-400">{labels.empty}</p>
      </div>
    ) : null}

    {!loading && !error && activities.length > 0 ? (
      <div className="flex flex-col">
        <div className="pb-4">
          {activities.map((activity) => (
            <div
              key={activity.id}
              className="flex items-start gap-4 py-[15px] border-b border-[#E2E8F0] dark:border-gray-700"
            >
              <div className="flex-shrink-0">
                {getNotificationIcon(activity.activity_type ?? "")}
              </div>
              <div className="flex-1 flex flex-col gap-1 min-w-0">
                <p className="font-semibold text-base text-[#101828] dark:text-gray-100 leading-[26px]">
                  {activity.title}
                </p>
                <time className="text-sm text-[#6A7282] dark:text-gray-400 leading-5">
                  {formatRelativeTime(activity.created_at)}
                </time>
              </div>
            </div>
          ))}
        </div>
        <div className="pt-8">
          <CommonPagination
            page={page}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      </div>
    ) : null}
  </>
);
